import * as z from "zod";

/**
 * What publishing the draft would do to the automation's runs in progress.
 * Runs on the `latest` strategy that are waiting (a wait step) move to the
 * new version, or are cancelled if the step they're on was removed or is a
 * different kind of step in the draft; other `latest` runs are decided at
 * their next wait; `pinned` runs stay on their version. A draft changed since
 * `draftRevision` is a conflict.
 */
export const previewPublish = {
  name: "previewPublish" as const,
  input: z.object({
    id: z.string(),
    /** The draftRevision the editor loaded or last saved. */
    draftRevision: z.string(),
  }),
  output: z.object({
    /** Runs that would continue on the new version. */
    moving: z.number().int(),
    /** Runs that would be cancelled. */
    ending: z.number().int(),
    /** Runs pending something other than a wait: they move or are cancelled at their next wait. */
    atNextWait: z.number().int(),
    /** Pinned runs, which finish on the version they're on. */
    staying: z.array(
      z.object({ version: z.number().int(), count: z.number().int() }),
    ),
    /** More runs are in progress than were counted; the counts are a floor. */
    truncated: z.boolean(),
    /** How many runs the counts cover at most. */
    limit: z.number().int(),
  }),
};
